declare var swal: any;
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';


import { FieldData } from '../../../../../models/actor/actor';


@Component({
    selector: 'auto-gen-datepv',
    templateUrl: './autogendatepv.component.html',
    styleUrls: ['./autogendatepv.component.scss']
})

export class AutoGenDatePVComponent implements OnInit {
    @Input() public mode;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  @Input() public field: FieldData;

    ngOnInit(): void {
       
    }

    //get selDate(): Date {
    //    var d: Date = Date.n;
    //    if (this.field != null)
    //        return Date.parse()
    //    return ( && this.field.Value == 'True');
    //}

    //@Input('selDate')
    //set selDate(value: boolean) {
    //    this.field != null
    //    {
    //        //  alert(this.field.Title + " before: " + this.field.Value + "  , New Value = " + value);
    //        if (value)
    //            this.field.Value = 'True';
    //        else
    //            this.field.Value = 'False';

    //        //  alert(this.field.Title + " After: " + this.field.Value );
    //    }
    //}

    //get isChecked(): Date {
    //    return (this.field != null && Date.parse(this.field.Value == 'True');
    //}

    //@Input('date')
    //set isChecked(value: Date) {
    //    this.field != null
    //    {
    //        alert(this.field.Title + " before: " + this.field.Value + "  , New Value = " + value);
    //        if (value)
    //            this.field.Value = 'True';
    //        else
    //            this.field.Value = 'False';

    //        alert(this.field.Title + " After: " + this.field.Value );
    //    }
    //}
}
